"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@folio/stripes/core");
var _zustand = require("zustand");
// We can use hooks within zustand store functions without violating the laws of hooks
/* eslint-disable react-hooks/rules-of-hooks */

const useIntlKeyStore = (0, _zustand.create)((set, get) => ({
  intlKeys: {},
  addKey: (key, namespace) => set(state => {
    let ns = namespace;
    const folioNS = (0, _core.useNamespace)()?.[0];
    if (!ns) {
      ns = folioNS;
    }
    return {
      ...state,
      intlKeys: {
        [ns]: key,
        ...state.intlKeys
      }
    };
  }),
  removeKey: namespace => set(state => {
    let ns = namespace;
    const folioNS = (0, _core.useNamespace)()?.[0];
    if (!ns) {
      ns = folioNS;
    }
    const {
      [ns]: _valueToRemove,
      ...newKeys
    } = state.intlKeys;
    return {
      ...state,
      intlKeys: newKeys
    };
  }),
  getKey: namespace => {
    let ns = namespace;
    const folioNS = (0, _core.useNamespace)()?.[0];
    if (!ns) {
      ns = folioNS;
    }
    return get().intlKeys?.[ns];
  }
}));
var _default = exports.default = useIntlKeyStore;